import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Anders Lindqvist",
    location: "Täby",
    text: "Fantastiskt resultat! Huset ser ut som nytt. Professionellt team som höll tidsplanen och städade upp efter sig. Rekommenderas varmt!",
    rating: 5,
  },
  {
    name: "Lena Eriksson",
    location: "Bromma",
    text: "Vi är så nöjda med vår nymålade fasad. Bra kommunikation genom hela projektet och ett fast pris som höll. Tack!",
    rating: 5,
  },
  {
    name: "Magnus Johansson",
    location: "Sollentuna",
    text: "Valde dem efter rekommendation från grannen och blev inte besviken. Kvalitetsarbete från början till slut. Kommer definitivt anlita igen.",
    rating: 5,
  },
];

const stats = [
  { value: "500+", label: "Nöjda kunder" },
  { value: "15+", label: "År i branschen" },
  { value: "100%", label: "Trähus-specialister" },
  { value: "4.9/5", label: "Snittbetyg" },
];

export default function TestimonialsSection() {
  return (
    <section className="section-padding bg-white" data-testid="testimonials-section">
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-sm font-semibold tracking-wider uppercase text-[#b91c1c]">
            Kundomdömen
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight">
            Vad våra kunder säger
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Vi är stolta över våra nöjda kunder. Här är några av deras upplevelser.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center" data-testid={`stat-${index}`}>
              <p className="text-4xl md:text-5xl font-bold text-slate-900">{stat.value}</p>
              <p className="text-slate-600 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="testimonial-card bg-slate-50 p-8 rounded-2xl relative"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-[#b91c1c]/20 absolute top-6 right-6" />
              
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              {/* Text */}
              <p className="text-slate-700 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-slate-200 rounded-full flex items-center justify-center">
                  <span className="text-lg font-semibold text-slate-600">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-slate-900">{testimonial.name}</p>
                  <p className="text-sm text-slate-600">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
